<template>
  <div class="info-wrapper">
    <div class="header">
      <p>{{ `รายละเอียดผู้นัด` }}</p>
    </div>
    <div class="content">
      <div class="item">
        <img :src="'/static/icons/supplier-icon/user-icon.svg'" />
        <p>{{ appointment.home.contact.name }}</p>
      </div>
      <div class="item">
        <img :src="'/static/icons/supplier-icon/tel-icon.svg'" />
        <p>{{ appointment.home.contact.phoneNumber }}</p>
      </div>
      <div class="item address">
        <img
          :src="'/static/icons/supplier-icon/address-icon.svg'"
          class="mt-1"
        />
        <p>{{ appointment.home.fullAddressText }}</p>
      </div>
      <div v-if="appointment.home.latLng" class="view-map">
        <p @click="viewMap(appointment.home.latLng)">
          {{ "ดูแผนที่" }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appointment: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    viewMap(address) {
      window.open(address, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.info-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: $white;
  overflow: hidden;

  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 24px;
    border-bottom: 1px solid #e6e6e6;

    p {
      color: $black;
      font-size: 18px;
      font-weight: bold;
    }
  }

  > .content {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
    padding: 16px 24px 8px 24px;

    > .item {
      display: flex;
      flex-direction: row;

      p {
        color: $black;
        font-size: $font-16;
        padding-left: 8px;
      }

      img {
        width: 24px;
      }
    }

    > .address {
      align-items: start;
    }

    > .view-map {
      width: fit-content;
      margin-top: -8px;
      padding-left: 24px;

      p {
        color: #e67e15;
        font-size: $font-14;
        font-weight: bold;
        cursor: pointer;
        padding: 8px;
      }
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .info-wrapper {
    > .header {
      padding: 8px 16px;
    }

    > .content {
      padding: 16px 16px 8px 16px;

      > .item {
        img {
          width: 20px;
        }
      }

      > .view-map {
        padding-left: 20px;
      }
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .info-wrapper {
    > .header {
      padding: 8px 16px;

      p {
        font-size: 16px;
      }
    }

    > .content {
      padding: 8px 16px 0 16px;

      > .item {
        p {
          font-size: $font-14;
        }

        img {
          width: 20px;
        }
      }

      > .view-map {
        padding-left: 20px;
        p {
          font-size: $font-12;
        }
      }
    }
  }
}
</style>
